import React, { useState, useEffect } from "react";
import { registerLoaderSetter } from "./loaderService";

export default function GlobalLoader() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    registerLoaderSetter(setLoading);
  }, []);

  if (!loading) return null;

  return (
    <div className="global-loader-overlay">
      <div className="global-loader-ring"></div>
      <p className="global-loader-text">Please wait...</p>
    </div>
  );
}
